import { useRouter } from "next/router";

import { ArticleCard } from "@baseComponents/ArticleCard";
import { useMediaQueryBreakpoint } from "@hooks";
import { portfolioArticleCards } from "@portfolios";

import { ArticlesFlexContainer, HeaderStyled } from "./CaseStudies.styled";

interface CaseStudiesProps {
  header: string;
  subheader: string;
}

export const CaseStudies = ({ header, subheader }: CaseStudiesProps) => {
  const { locale } = useRouter();
  const { isTablet, tabletThreshold } = useMediaQueryBreakpoint();
  const articleCardSize = isTablet ? "medium" : "small";

  const articles = portfolioArticleCards.map(({ pl, en }) =>
    locale === "pl" ? pl : en,
  );

  return (
    <div className="my-12">
      <HeaderStyled>
        <h2>{header}</h2>
        <p>{subheader}</p>
      </HeaderStyled>

      <ArticlesFlexContainer>
        <ArticleCard
          size={articleCardSize}
          {...articles[0]}
          nextImageSizes={`(min-width: ${tabletThreshold}px) 50vw, 100vw`}
        />
        <ArticleCard
          size={articleCardSize}
          {...articles[1]}
          nextImageSizes={`(min-width: ${tabletThreshold}px) 50vw, 100vw`}
        />
      </ArticlesFlexContainer>
    </div>
  );
};
